module.exports = __webpack_public_path__ + "faea9ebd9ce01aa00a87a63f746bb538.png";